Object.filter = function (obj, validate) {
  var result = {},
    key;

  for (key in obj) {
    if (obj.hasOwnProperty(key) && validate(obj[key])) {
      result[key] = obj[key];
    }
  }

  return result;
};

Object.filterKey = function (obj, validate) {
  var result = {},
    key;

  for (key in obj) {
    if (obj.hasOwnProperty(key) && validate(key)) {
      result[key] = obj[key];
    }
  }

  return result;
};

Object.sortBy = function (obj, sortBy) {
  if (!sortBy) sortBy = 'Sort';

  if (obj === null || obj === undefined) return [];

  if (typeof obj === "object" && obj.length === 0) return [];

  return Object.values(obj).sort(function (a, b) {
    return a[sortBy] - b[sortBy];
  });
}

Number.prototype.Format = function (n, x, s, c) {
  var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
    num = this.toFixed(Math.max(0, ~~n));

  return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};

Number.prototype.Decimal = function () {
  return String(this).Decimal();
}

Number.prototype.DecimalFix = function () {
  return String(this).DecimalFix();
}

Number.prototype.toFloat = function () {
  return String(this).toFloat();
}

Number.prototype.toNumPad = function () {
  return String(this).toNumPad();
}

Number.prototype.Money = function (Currency) {
  return String(this).Money(Currency);
}

String.prototype.Format = function (n, x, s, c) {
  var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
    num = parseFloat(String(this).replace(',', '.')).toFixed(Math.max(0, ~~n));

  return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};

String.prototype.Decimal = function () {
  return this.toFloat().Format(2, 3, '.', ',');
}

String.prototype.DecimalFix = function () {
  return this.toFloat().Format((this.toFloat() % 1 > 0 ? 2 : 0), 3, '.', ',');
}

String.prototype.toFloat = function () {
  var Num = this.replace(/[^0-9.,]+/g, '');

  if (Num.indexOf(',') === -1 && Num.indexOf('.') === -1) {
    return Number(Num).toFixed(2);
  } else {
    var LastComma = Num.lastIndexOf(',');
    var LastDot = Num.lastIndexOf('.');

    var Splitter = (LastComma > LastDot) ? ',' : '.';

    var Integer = Num.substring(0, Num.lastIndexOf(Splitter));
    var IntegerCleaned = String(Integer).replace(/[,|.]+/g, '');
    var Decimal = Num.substring(Num.lastIndexOf(Splitter) + 1);

    return Number(IntegerCleaned + '.' + Decimal).toFixed(2);
  }
}

String.prototype.toNumPad = function () {
  return String(this.DecimalFix()).replace('.', '');
}

String.prototype.Money = function (Currency) {
  const _Currency = Currency || 'TL';

  return this.toFloat().Format(2, 3, '.', ',') + ' ' + _Currency;
}